import React, { useEffect, useMemo, useState } from "react";
import { ChargeAnalysis } from "../../pages";
import constant from "../../utils/constant";
import { toJS } from "mobx";
import { TransactionsController } from "../../controllers";
import { transactionStore } from "../../stores";

const ChargeAnalysisContainer = () => {
  const [loading, setLoading] = useState(false);

  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const chargeAnalysisTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } =
    TransactionsController.useGetChargeAnalysis(
      chargeAnalysisTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  return (
    <ChargeAnalysis
      loading={loading}
      chargeAnalysis={toJS(transactionStore.chargeAnalysis)}
      isLoading={isLoading}
      data={data}
      isFetching={isFetching}
      limit={limit}
      onLimitChange={onLimitChange}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setSearchQuery={setSearchQuery}
      setFilterQuery={setFilterQuery}
    />
  );
};

export default ChargeAnalysisContainer;
